import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  ADMISSIONS_ACKNOWLEDGEMENT_PATH,
  ADMISSIONS_DETAILS_FILTER_PATH,
  ADMISSIONS_DETAILS_PATH,
  ADMISSIONS_DETAILS_SUBSIDIES_PATH,
  ADMISSIONS_PATH,
  ADMISSIONS_PAYMENT_CALLBACK_PATH,
  ADMISSIONS_PAYMENT_HISTORY_PATH,
  ADMISSIONS_PAYMENT_PATH,
  ADMISSIONS_PAYMENT_STATUS_PATH,
  ADMISSIONS_PAYMENT_WAITING_STATUS_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const AdmissionListPage = lazy(() => import('./pages/AdmissionListPage/AdmissionListPage'));
const AcknowledgementPage = lazy(() => import('./pages/AcknowledgementPage/AcknowledgementPage'));
const AdmissionDetailsPage = lazy(() => import('./pages/AdmissionDetailsPage/AdmissionDetailsPage'));
const SubsidiesPage = lazy(() => import('./pages/SubsidiesPage/SubsidiesPage'));
const FilterByFeaturesPage = lazy(() => import('./pages/FilterByFeaturesPage/FilterByFeaturesPage'));
const MakePaymentPage = lazy(() => import('./pages/MakePaymentPage/MakePaymentPage'));
const PaymentStatusPage = lazy(() => import('./pages/PaymentStatusPage/PaymentStatusPage'));
const PaymentCallbackPage = lazy(() => import('./pages/PaymentCallbackPage/PaymentCallbackPage'));
const PaymentWaitingEnetsStatusPage = lazy(
  () => import('./pages/PaymentWaitingEnetsStatusPage/PaymentWaitingEnetsStatusPage')
);
const PaymentHistoryPage = lazy(() => import('./pages/PaymentHistoryPage/PaymentHistoryPage'));

export const ADMISSION_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <AdmissionListPage />,
    displayTitle: () => 'Admissions',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <AcknowledgementPage />,
    displayTitle: () => 'Acknowledgement of Financial Counselling',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_ACKNOWLEDGEMENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    backUrl: ADMISSIONS_PATH,
    component: () => <AdmissionDetailsPage />,
    displayTitle: () => 'Admissions',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <FilterByFeaturesPage />,
    displayTitle: () => 'Admissions',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_DETAILS_FILTER_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <SubsidiesPage />,
    displayTitle: () => 'Admissions',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_DETAILS_SUBSIDIES_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <MakePaymentPage />,
    displayTitle: () => 'Admissions',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_PAYMENT_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.COMMON],
    component: () => <PaymentCallbackPage />,
    displayTitle: () => 'Payment Callback',
    pageType: PageType.PUBLIC,
    path: ADMISSIONS_PAYMENT_CALLBACK_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <PaymentStatusPage />,
    displayTitle: () => 'Payment Status',
    pageType: PageType.PRIVATE,
    path: `${ADMISSIONS_PAYMENT_STATUS_PATH}/:id`,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <PaymentWaitingEnetsStatusPage />,
    displayTitle: () => 'Make Payment',
    pageType: PageType.PRIVATE,
    path: `${ADMISSIONS_PAYMENT_WAITING_STATUS_PATH}/:id`,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.SHARED],
    component: () => <PaymentHistoryPage />,
    displayTitle: () => 'Admissions',
    pageType: PageType.PRIVATE,
    path: ADMISSIONS_PAYMENT_HISTORY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.admissions,
  },
];
